import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-accent-500">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
          随时随地，畅享高清观影
        </h2>
        <p className="text-background-50/85 text-sm md:text-base max-w-xl mx-auto mb-8">
          下载糖心视频APP，海量影视资源随身带。高清不缓冲，免费追剧随时随地。
        </p>
        <div className="flex items-center justify-center gap-4 flex-wrap">
          <button className="bg-background-50 hover:bg-background-100 text-accent-600 px-8 py-3.5 rounded-lg font-semibold text-sm transition-all cursor-pointer whitespace-nowrap inline-flex items-center gap-2">
            <i className="ri-apple-fill text-lg"></i> App Store 下载
          </button>
          <button className="bg-background-950/20 hover:bg-background-950/30 text-background-50 px-8 py-3.5 rounded-lg font-semibold text-sm transition-all cursor-pointer whitespace-nowrap inline-flex items-center gap-2 border border-background-50/30">
            <i className="ri-android-line text-lg"></i> Android 下载
          </button>
        </div>
      </div>
    </section>
  );
}